// Keep the bridge envelope in sync with Frontend/src/pages/public/SalesDemo/salesDemoBridge.ts.
// No project key, account token or API host crosses this bridge.
export const SALES_DEMO_CHANNEL = "gleap-sales-demo-v1";
export const isSalesDemoMode = () => window.location.pathname.replace(/\/+$/, "") === "/sales-demo";

export const salesDemoParentOrigin = (value: string | null): string | null => {
  try {
    const url = new URL(value ?? "");
    if (url.origin !== value || url.username || url.password) return null;
    if (url.protocol === "https:" && ["app.gleap.ai", "app.gleap.io"].includes(url.hostname)) return url.origin;
    if (["http:", "https:"].includes(url.protocol) && ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname)) return url.origin;
  } catch {}
  return null;
};

export const isSalesDemoMessage = (event: Pick<MessageEvent, "origin" | "source" | "data">, origin: string, parent: Window, channel: string) =>
  event.origin === origin && event.source === parent &&
  !!event.data && typeof event.data === "object" &&
  event.data.channel === SALES_DEMO_CHANNEL && event.data.instance === channel;

let targetOrigin: string | null = null;
let instance = "";
export const configureSalesDemoBridge = (origin: string, channel: string) => { targetOrigin = origin; instance = channel; };
export const sendSalesDemoMessage = (type: string, data?: unknown) => {
  if (!targetOrigin) return;
  window.parent.postMessage({ channel: SALES_DEMO_CHANNEL, instance, type, data }, targetOrigin);
};

export const openSalesDemoUrl = (value: unknown) => {
  try {
    const url = new URL(String(value));
    if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) return;
    window.open(url.href, "_blank", "noopener,noreferrer");
  } catch {}
};

// The regular SDK message listener stays disconnected in demo mode. Only these
// visual events leave the iframe; there are no SDK actions or live ticket calls.
export const handleSalesDemoWidgetMessage = (message: { name?: string; data?: unknown }) => {
  if (message.name === "close-widget") sendSalesDemoMessage("close");
  if (message.name === "open-url") openSalesDemoUrl(message.data);
};
